import { Card, CardContent, Chip, styled, TextField, Tooltip } from '@mui/material';
import { typography } from "../../theme/typography";
import { neutral, primary } from "../../theme/colors";
import { useThemeContext } from "../../theme/ThemeContextProvider";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import { useTranslation } from "react-i18next";

interface MailCardProps {
    chips: string[];
    handleChipDelete: (chip: string) => void;
    label: string;
    value: string;
    onChange: (value: string) => void;
    onKeyDown: (event: React.KeyboardEvent<HTMLDivElement>) => void;
    error: boolean;
}

const MailCard: React.FC<MailCardProps> = ({
                                               chips,
                                               handleChipDelete,
                                               label,
                                               value,
                                               onChange,
                                               onKeyDown,
                                               error,
                                           }) => {

    const {mode} = useThemeContext();
    const { t } = useTranslation();

    const MailChip = styled(Chip)({
        backgroundColor: mode === "light" ? primary[100] : primary[800],
        border: "none",
        color: mode === "light" ? primary[700] : primary[50],
    });

    return (
        <Card sx={{ mb: 3 }}>
            <CardContent>
                <TextField
                    sx={{
                        '& .MuiInputBase-input': {
                            ...typography.titleMd,
                        },
                        '& .MuiInput-underline:before': {
                            borderBottom: !value ? '1px dashed' : '1px solid',
                            borderBottomColor: mode === 'light' ? neutral[200] : neutral[600]
                        },
                        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                            borderBottomColor: mode === 'light' ? neutral[200] : neutral[600],
                        },
                    }}
                    label={label}
                    variant='standard'
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    onKeyDown={onKeyDown}
                    fullWidth
                    error={error}
                    slotProps={{
                        input: {
                            style: {
                                fontWeight: 'bold',
                            },
                        }
                    }}
                />
                {chips.map(chip => (
                    <MailChip
                        key={chip}
                        label={chip}
                        onDelete={() => handleChipDelete(chip)}
                        sx={{ marginRight: 1, marginTop: 1 }}
                        deleteIcon={
                            <Tooltip title={t("GENERAL.DELETE")}>
                                <CloseIcon sx={{ width: "20px", height: "20px", fill: mode === 'light' ? primary[700] : primary[50]}} />
                            </Tooltip>
                        }
                    />
                ))}
            </CardContent>
        </Card>
    );
};

export default MailCard;
